export default __webpack_public_path__ + "static/nebiyu-0cd09a6dab946458b94ae568b7193cd1.png";